interface SweepBarProps {
  signalId: string;
  variant?: 'default' | 'applied';
}

const hashCode = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }
  return Math.abs(hash);
};

const gradients = {
  default: 'linear-gradient(90deg, transparent, #5E6AD2, #7B85E0, transparent)',
  applied: 'linear-gradient(90deg, transparent, #8b6fb5, #a78bca, transparent)',
};

export const SweepBar = ({ signalId, variant = 'default' }: SweepBarProps) => {
  const hash = hashCode(signalId);
  const duration = 4 + (hash % 3);
  const delay = (hash % 5) * 0.8;

  return (
    <div
      className="absolute bottom-0 start-0 h-0.5"
      style={{
        background: gradients[variant],
        animation: `signal-sweep ${duration}s ease-in-out ${delay}s infinite`,
      }}
    />
  );
};
